import { render, staticRenderFns } from "./PgRequestEvidenceControl.vue?vue&type=template&id=764407fa&"
import script from "./PgRequestEvidenceControl.vue?vue&type=script&lang=js&"
export * from "./PgRequestEvidenceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports